import { FunctionComponent } from 'react';
import styles from "./WaterbodiesCampaignCard.module.css";
import cn from 'classnames';
import {Card} from 'react-bootstrap';
import { ASSESTS } from '../../../../../../../constant/assest';

export enum IWaterbodiesCampaignStatus {
    ACTIVE= 'active',
    EXPIRE= 'expire',
    INACTIVE= 'iactive',
    SCHEDULED= 'scheduled',
};

interface IWaterbodiesCampaignCardProps {
    className?: string;
};

const WaterbodiesCampaignCard: FunctionComponent<IWaterbodiesCampaignCardProps> = ({ className }) => {

    return (
        <Card bsPrefix={cn(styles.waterbodiesCampaignCard, className)}>
            <Card.Header bsPrefix={styles.header}>
                <div className={cn(styles.headercol, styles.statusCol)}>
                    <span className={styles.status}>Sent</span>
                </div>
                <div className={cn(styles.headercol, styles.dateCol)}>
                    20/1/2024
                </div>
            </Card.Header>
            <Card.Body bsPrefix={styles.body}>
                <Card.Title bsPrefix={styles.title} as={'div'}>Spring Bass Season Alert-Crystal Lake</Card.Title>
                <Card.Text bsPrefix={styles.text} as={'div'}>Great news! Bass activity has increased significantly at Crystal Lake. Water temperature is perfect at 68°F. Best fishing spots are near the north shore and around the...</Card.Text>
                <div className={styles.tags}>
                    <span className={styles.tag}>Crystal Lake</span>
                    <span className={styles.tag}>South West</span>
                </div>
            </Card.Body>
            <Card.Footer bsPrefix={styles.foorer}>
                <div className={cn(styles.foorercol, styles.recipients)}>
                    <Card.Title as={'div'} bsPrefix={styles.label}>Recipients</Card.Title>
                    <Card.Text as={'div'} bsPrefix={styles.value}>1,250</Card.Text>
                </div>
                <div className={cn(styles.foorercol, styles.radius)}>
                    <Card.Title as={'div'} bsPrefix={styles.label}>Radius</Card.Title>
                    <Card.Text as={'div'} bsPrefix={styles.value}>15km</Card.Text>
                </div>
            </Card.Footer>
        </Card>
    );
};

export default WaterbodiesCampaignCard;
